import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal, Type } from '@angular/core';
import { IconRoute } from '../../../../app.routes';
import { TagModule } from 'primeng/tag';
import { CesButtonSecondaryComponent } from '../../../ui/ces-buttons';
import {
  GenericSidebarComponent,
  SidebarFooterDirective,
  SidebarHeaderDirective,
  SidebarSection,
} from '../../../ui/sidebar/generic-sidebar/generic-sidebar.component';

export interface MockIconRoute {
  path: string;
  title: string;
  icon: string;
  component?: Type<unknown>;
  disabled?: boolean;
}

@Component({
  selector: 'app-demo-sidebar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GenericSidebarComponent, SidebarHeaderDirective, SidebarFooterDirective, TagModule, CesButtonSecondaryComponent],
  templateUrl: './demo-sidebar.component.html',
})
export class DemoSidebarComponent {
  readonly isCollapsedSignal = signal(false);

  @Input()
  set isCollapsed(value: boolean) {
    if (value !== this.isCollapsedSignal()) {
      this.isCollapsedSignal.set(value);
    }
  }

  get isCollapsed(): boolean {
    return this.isCollapsedSignal();
  }

  @Output() isCollapsedChange = new EventEmitter<boolean>();

  @Input() sections: SidebarSection[] = [];
  @Input() baseRoutePath = 'demo';
  @Input() isDisabledFn: (route: IconRoute) => boolean = () => false;
  @Input() activeRoutePath = '';
  @Output() toggleActiveRoute = new EventEmitter<void>();
  @Output() homeNavigate = new EventEmitter<void>();
}
